// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"abb9be57","211":"47aa83f8","281":"0295e291","344":"f374cf5d","634":"fbae406d","683":"46f47d11","787":"6034518f","938":"c657d944"}[chunkId] + ".chunk.js";
};